import {
  ALL_LABELS_VALUE,
  CAMPAIGN_POST_SORT,
  EMPTY_LABEL_VALUE,
  CampaignStatus,
} from '@/entities/campaign';
import type { PostViewMode } from '@/features/campaign/ui/campaign-detail/hooks';
import type { BadgeProps } from '@/shared/components/shadcn/badge';
import { ConstMap } from '@/shared/utils/const-map';
import type { CampaignListFilter } from '../../hooks';

export { ALL_LABELS_VALUE, EMPTY_LABEL_VALUE };

export const statusConfigs = new ConstMap<
  CampaignListFilter,
  {
    label: string;
    variants: NonNullable<BadgeProps['variant']>;
  }
>([
  [
    'all',
    {
      label: 'All',
      variants: 'default',
    },
  ],
  [
    CampaignStatus.SCHEDULED,
    {
      label: 'Scheduled',
      variants: 'outline',
    },
  ],
  [
    CampaignStatus.ACTIVE,
    {
      label: 'Active',
      variants: 'default',
    },
  ],
  [
    CampaignStatus.ENDED,
    {
      label: 'Ended',
      variants: 'secondary',
    },
  ],
]);

export const TOTAL_ENGAGEMENTS_FORMULA = 'Total engagements = Likes + Comments + Shares';
export const ENGAGEMENT_RATE_FORMULA = 'ER = (Likes + Comments + Shares) / Views';
export const POST_ER_FORMULA = 'Post ER = (Likes + Comments + Shares) / Views';
export const RECENT_POSTS_TOOLTIP = 'Posts first collected since yesterday 12:00 AM';

export const postSortOptions: Array<{
  label: string;
  value: CAMPAIGN_POST_SORT;
  helper?: string;
}> = [
  { label: 'Newest posted', value: CAMPAIGN_POST_SORT.POSTED_AT_DESC },
  { label: 'Views', value: CAMPAIGN_POST_SORT.VIEW_DESC },
  { label: 'Comments', value: CAMPAIGN_POST_SORT.COMMENT_DESC },
  { label: 'Likes', value: CAMPAIGN_POST_SORT.LIKE_DESC },
  { label: 'Shares', value: CAMPAIGN_POST_SORT.SHARED_DESC },
  {
    label: 'Engagement rate',
    value: CAMPAIGN_POST_SORT.RATE_DESC,
    helper: ENGAGEMENT_RATE_FORMULA,
  },
];

export const postViewModeOptions: Array<{ label: string; value: PostViewMode }> = [
  { label: 'Card view', value: 'card' },
  { label: 'List view', value: 'list' },
];

export const ALL_PLATFORMS_VALUE = '__all_platforms__';
export const CREATORS_PAGE_SIZE = 10;
export const POSTS_PAGE_SIZE = 10;
